import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const CountryFlag = ({ flag, name }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    if (anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setPos({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
      });
    }
    const onMouseDown = (e) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(e.target) &&
        anchorRef.current &&
        !anchorRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onMouseDown);
    return () => document.removeEventListener("mousedown", onMouseDown);
  }, [open]);

  if (!flag) return null;

  return (
    <>
      <img
        ref={anchorRef}
        src={flag}
        alt={name || "flag"}
        width={20}
        height={14}
        className="pointer"
        style={{ objectFit: "cover", borderRadius: 2, flexShrink: 0 }}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      />
      {open &&
        name &&
        createPortal(
          <div
            ref={tooltipRef}
            className="tooltip inria-sans-400 font-14"
            style={{
              position: "absolute",
              top: pos.top,
              left: pos.left,
              zIndex: 9999,
            }}
          >
            {name}
          </div>,
          document.body,
        )}
    </>
  );
};

export default CountryFlag;
